import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpIOService } from 'src/app/services/http-io.service';

@Component({
  selector: 'app-sme-support',
  templateUrl: './sme-support.component.html',
  styleUrls: ['./sme-support.component.scss']
})
export class SmeSupportComponent implements OnInit {
  consultationForm!: FormGroup;
  isSubmitting = false;

  constructor(private fb: FormBuilder, private io: HttpIOService) { }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.consultationForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required]
    });
  }

  navigationFromCTA(): void {
    document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' });
  }


  onSubmit(): void {
    if (this.consultationForm.valid) {
      this.isSubmitting = true;
      const formData = this.consultationForm.value;

      console.log('Form Submitted:', formData);

      const message = `Name: ${this.consultationForm.value.name},
      Phone: ${this.consultationForm.value.phone}`;

      let payload = {
        path: '/helpdesk-email',
        message: message,
        email: this.consultationForm.value.email,
        subject: "SME Support",
      }

      this.io._helpDeskEmail(payload).subscribe(
        (res: any) => {
          console.log("Form Submitted Successfully", res)
        },
        (err: any) => {
          console.log("Form Submission Failed", err)
        }
      );

      setTimeout(() => {
        this.isSubmitting = false;
        this.consultationForm.reset();
        alert('Thank you! We have received your request and will contact you shortly.');
      }, 1500);

    } else {
      this.consultationForm.markAllAsTouched();
    }
  }
}